import { render, staticRenderFns } from "./SelectUserDialog.vue?vue&type=template&id=55f07770&scoped=true"
import script from "./SelectUserDialog.vue?vue&type=script&lang=js"
export * from "./SelectUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f07770",
  null
  
)

export default component.exports